{
	"cardTitle": "Pour votre sécurité, votre session a expiré.",
	"loginButtonLabel": "Se reconnecter"
}
